import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="13" height="12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M0 0h5v12H0V0zm8 0h5v12H8V0z" fill="#666" /></svg>;